import Layout from '../../components/feature/Layout';
import AboutHero from './components/AboutHero';
import MissionSection from './components/MissionSection';
import ValuesSection from './components/ValuesSection';
import CommitmentSection from './components/CommitmentSection';

export default function AboutPage() {
  return (
    <Layout>
      <AboutHero />
      <MissionSection />
      <ValuesSection />
      <CommitmentSection />
    </Layout>
  );
}
